export default "__VITE_ASSET__BK3o_Li4__"